const DayliAnnouncment = () => {
  return <div>Dnevni oglasi</div>
}

export default DayliAnnouncment
